import { useState } from 'react';
import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, } from '@mui/material'
interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
}
export default function AddQueries({ open, onClose, setOpen }: ModalProps) {
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [error, setError] = useState(false);
    return (
        <Modal
            className="modal addNotification_modal"
            open={open}
            onClose={() => {
                onClose();
                setError(false);
            }}>
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Queries Amount</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>
                    <form className="form" action="">
                        <div className="control_group">
                            <label htmlFor="num-queries">Number of Queries</label>
                            <TextField
                                placeholder="Enter"
                                fullWidth
                                value={question}
                                onChange={(e) => setQuestion(e.target.value)}
                                hiddenLabel
                                inputProps={{ id: "num-queries" }}
                            />
                        </div>
                        <div className="control_group">
                            <label htmlFor="queries-amount">Amount</label>
                            <TextField
                                placeholder="Amount"
                                fullWidth
                                value={question}
                                onChange={(e) => setQuestion(e.target.value)}
                                hiddenLabel
                                inputProps={{ id: "queries-amount" }}
                            />
                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={() => {
                                setError(false);
                                setOpen(false)
                            }}>Cancel</Button>
                            <Button className="btn btn_primary" onClick={() => {
                                setError(true);
                                setOpen(false)
                                if (question == "") {
                                    // showError("Question is required");
                                    return;
                                }
                                if (answer == "") {
                                    // showError("Answer is required")
                                    return;
                                }
                                setAnswer("");
                                setQuestion("");
                                setError(false);
                                setOpen(false);
                            }}>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal >
    )
}
